import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import API from '../../tools/API';
import OptionTable from "../../components/OptionTables/OptionTable";
import Modal from "../../components/Modal/Modal";
import AddOptionModal from "../../components/Modal/AddOptionModal";
import DragOptionTable from "../../components/OptionTables/DragOptionTable";

import styles from "./SingleVoting.module.scss";
import { Poll, Options } from '../../tools/interfaces';

const SingleVoting = () => {
    const { id } = useParams();
    const [poll, setPoll] = useState<Poll | null>(null);
    const [options, setOptions] = useState<Options[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [tagList, setTagList] = useState([]);
    const [droppableId, setDroppableId] = useState("1");
    const [drag, setDrag] = useState(false);

    useEffect(() => {
        API.getSinglePoll(id as string).then((res) => {
            setPoll(res?.data.data);
        })
        API.getListOfPollOptions(id).then((res) => {
            setOptions(res?.data.data);
        })
        API.getListOfTags().then((res) => {
            setTagList(res?.data.data);
        })
    }, [showModal]);

    const getNewOptionsOrder = () => {
        const optionIdArray: number[] = [];
        options.map((el) => {
            optionIdArray.push(el.id);
        })
        API.reorderPollOptions(parseInt(id as string), optionIdArray);
    }

    const onDragEnd = (result: any) => {
        if (!result.destination) return;
        const items = Array.from(options);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setOptions(items);
    }

    const checkIfStarted = () => new Date() < new Date(poll!.votingFrom);

    return (
        <section className={styles.main}>
            <div className={styles.topRow}>
                {poll && checkIfStarted() &&
                    <div>
                        {!drag ?
                            (<button
                                className={styles.btnEdit}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShowModal(true);
                                }
                                }
                            >
                                <div className={styles.addIcon}></div>Dodaj opcję
                            </button>) :
                            (<button
                                className={styles.btnEdit}
                                style={{ padding: drag ? "10px 25px" : "10px 10px" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    API.getListOfPollOptions(id).then((res) => {
                                        setOptions(res?.data.data);
                                    })
                                    setDrag(false);
                                }
                                }
                            >
                                ANULUJ
                            </button>)
                        }
                        <button
                            className={styles.btnEdit}
                            onClick={() => {
                                if (!drag) {
                                    setDroppableId(Date());
                                    setDrag(!drag);
                                } else {
                                    getNewOptionsOrder();
                                    setDrag(!drag);
                                }
                            }}
                            style={{ backgroundColor: drag ? "green" : "#e10626", padding: drag ? "10px 47px" : "12px 30px" }}
                        >
                            {
                                !drag ? <div className={styles.shuffleIcon}></div> : ''
                            }
                            {
                                !drag ? "Zmień kolejność" : "ZAPISZ"
                            }
                        </button>
                    </div>
                }
            </div>
            <div className={styles.pollData}>
                <h2 className={styles.pollName}>{poll?.name}</h2>
                <div className={styles.optionsWrapper}>
                    {drag &&
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId={droppableId}>
                                {(provided) => (
                                    <ol className={styles.optionList} {...provided.droppableProps} ref={provided.innerRef}>
                                        {options && (
                                            options.map((el, index) => {
                                                return (
                                                    <Draggable key={el.order} draggableId={"draggable-" + el.id} index={index}>
                                                        {(provided) => (
                                                            <li
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                ref={provided.innerRef}
                                                            >
                                                                <DragOptionTable
                                                                    artist={el.artist}
                                                                    title={el.title}
                                                                    image={el.image}
                                                                    index={index}
                                                                />
                                                            </li>
                                                        )}
                                                    </Draggable>
                                                )
                                            })
                                        )

                                        }
                                        {provided.placeholder}
                                    </ol>
                                )}
                            </Droppable>
                        </DragDropContext>
                    }
                    {!drag &&
                        <ol className={styles.optionList}>
                            {options && (
                                options.map((el, index) => {
                                    return (
                                        <li key={index}>
                                            <OptionTable
                                                data={el}
                                                pollId={id}
                                                tagList={tagList}
                                                setOptions={setOptions}
                                                index={index}
                                                votingFrom={poll?.votingFrom}
                                            />
                                        </li>
                                    )
                                }
                                )
                            )}
                        </ol>
                    }
                </div>
            </div>
            {
                showModal &&
                <Modal openModal={setShowModal}>
                    <AddOptionModal openModal={setShowModal} pollId={id} tagList={tagList} />
                </Modal>
            }
        </section >
    )
}

export default SingleVoting;